export const default_fee_type_arr = [
    {name:'小时', value:1},
    {name:'半小时', value:2},
    {name:'分钟', value:3}
]

export const default_fee_type_obj = default_fee_type_arr.reduce((obj, item) => {
    obj[item.value] = item.name;
    return obj;
}, {});